import post from './post'

const postImage = (file) => {
  const data = new FormData()
  data.append('image', file)
  return post('/images', data)
}

export default postImage